import { IMenuItem } from "Core/Interfaces";
import { BaseService } from "./BaseService";
import { Configuration } from "Configuration";
import { CoreContext } from "Core";

const MENU_STORAGE_KEY: string = "dms-menu";

/**
 * Service which gets the menu.
 * @hidden
 */
export class MenuService extends BaseService {
    /**
     * Get the menu storage key.
     */
    private getKey(): string {
        let prefix = "";
        if (CoreContext.Environment) {
            prefix = CoreContext.Environment.UniqueApplicationName + "_";
        }
        return prefix + "_" + MENU_STORAGE_KEY;
    }

    /**
     * Get menu items.
     */
    public get(): Promise<IMenuItem[]> {
        // try to get from sessionstorage.
        let menuItems = sessionStorage.getItem(this.getKey());
        if (menuItems != null) {
            return Promise.resolve(JSON.parse(menuItems));
        }
        return this.ajaxget<IMenuItem[]>(Configuration.baseUrl + "menu").then((data: IMenuItem[]) => {
            sessionStorage.setItem(this.getKey(), JSON.stringify(data));
            return data;
        });
    }

    /**
     * Clears the menu cache.
     */
    public clearCache(): void {
        sessionStorage.removeItem(this.getKey());
    }
}
